import { getSelectedTableView } from 'owa-mail-list-store';
import { incrementLikeButtonCount } from 'owa-mail-reading-pane-store/lib/actions/itemActions/incrementLikeButtonCount';
import { updateLikeUnlikeInProgress } from 'owa-mail-reading-pane-store/lib/actions/itemActions/updateLikeUnlikeInProgress';
import { MaxLocalLikes } from 'owa-mail-reading-pane-store/lib/store/schema//LikeUnlikeTracker';
import ItemViewState from 'owa-mail-reading-pane-store/lib/store/schema/ItemViewState';
import { ClientItem, InstrumentationContext } from 'owa-mail-store';
import { lazyLikeItem } from 'owa-mail-triage-action';
import Message from 'owa-service/lib/contract/Message';
import * as React from 'react';

export default function onLikeUnLike(
    clientItem: ClientItem,
    instrumentationContext: InstrumentationContext,
    viewState: ItemViewState
) {
    return (event: React.MouseEvent<HTMLElement>) => {
        event.stopPropagation();
        if (!viewState.likeUnlikeTracker?.likeUnlikeInProgress) {
            updateLikeUnlikeInProgress(viewState, true /* likeUnlikeInProgress */);
            asyncLikeItem(clientItem, instrumentationContext, viewState);
        }
    };
}

const asyncLikeItem = async (
    clientItem: ClientItem,
    instrumentationContext: InstrumentationContext,
    viewState: ItemViewState
) => {
    const likeItem = await lazyLikeItem.import();
    incrementLikeButtonCount(viewState);

    likeItem(
        {
            ...clientItem.ItemId,
            mailboxInfo: clientItem.MailboxInfo,
        },
        clientItem as Message,
        getSelectedTableView(),
        viewState.likeUnlikeTracker?.likeButtonClickCount >= MaxLocalLikes /* isLocalUpdateOnly */,
        instrumentationContext
    );

    updateLikeUnlikeInProgress(viewState, false /* likeUnlikeInProgress */);
};
